// _exit-ring.js — the exit trigger's ring radius (coord ASK-159 §2.18dl; contracts/arrival-rule-fixture.json
// `rule.exitRing`). Pure, tiny, eager: stage.js `_shellExitRadius` reads it at compose, and the lazy arrival rule
// (`_spawn-clearance.js`) re-exports it, so the trigger and the arrival rule read ONE ring.

/** The exit ring when EXIT_ANCHOR carries no usable scale (coord contracts/arrival-rule-fixture.json
 *  `rule.exitRing.fallbackM`). An unscaled marker reads 1.0 too — glTF's default scale is 1. */
export const EXIT_RING_FALLBACK_M = 1.0;
const EXIT_RING_MIN_SCALE = 0.05;

/**
 * The exit trigger's ring radius from EXIT_ANCHOR's (world) scale — ASK-159 §2.18dl: the marker's scale IS the
 * door's half-width (0.45 m on the 4 × 3 m storefront), so the ring matches the door it guards. scale.x when it is
 * a number above 0.05 (the comic shells author (0.6, 0.05, 0.05): x is the ring); anything else → the fallback.
 * Accepts a THREE.Vector3 / {x,y,z} or a glTF node's [x, y, z].
 */
export function exitRingRadius(scale) {
	const x = Array.isArray(scale) ? scale[0] : scale?.x;
	return typeof x === "number" && Number.isFinite(x) && x > EXIT_RING_MIN_SCALE ? x : EXIT_RING_FALLBACK_M;
}
